// extracted by mini-css-extract-plugin
module.exports = {"image":"VideoHls_image__O35VC","hide":"VideoHls_hide__Hv2ZZ"};